var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper"},[_c('div',{staticClass:"header-box"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"logo",attrs:{"title":"神奇管家"}})])])])
}]

export { render, staticRenderFns }